// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import { Locale } from 'jsw';
import apolloClient from 'apolloClient';

import IIS_APP_POOL_DOMAIN_SETTINGS_PAGE from 'queries/IisAppPoolDomainSettingsPage.graphql';

export const iisAppPoolDomainSettingsRoute = {
    path: 'iis-app-pool/settings',
    componentLoader: () => import(
        /* webpackChunkName: "components/pages/IisAppPoolPage/IisAppPoolDomainSettingsPage" */'components/pages/IisAppPoolPage/IisAppPoolDomainSettingsPage'),
    loader: async ({ params }) => {
        const { data } = await apolloClient.query({
            query: IIS_APP_POOL_DOMAIN_SETTINGS_PAGE,
            variables: { id: btoa(`Domain:${params.domainId}`) },
        });

        if (!data.iisManager.appPoolSupported || data.domain.htype !== 'VIRTUAL') {
            throw new Response('Not Found', { status: 404 });
        }

        return data;
    },
    handle: {
        helpContext: 'iisapppool',
        crumb: ({ matchesContext, params }) => {
            const { domain } = matchesContext.domainRouteData;
            const locale = Locale.getSection('components.routes');

            return [
                {
                    title: locale.lmsg('iisAppPoolDomainSettings', { domain: `<b>${domain.name}</b>` }),
                    href: `/cp/domains/${params.domainId}/iis-app-pool/settings`,
                },
            ];
        },
    },
};
